/**
 * Created by staffanrantzow on 07/10/16.
 */

import * as types from './action-types';

/*
 * Keeps track of scroll position and currently fetched page on invoices.
  * So if user clicks back on an invoice they should be returned
  * to the previously set scroll position.
 */
const initialState = {
  scrollPosition: 0,
  invoice: {
    page: 1
  },
  preregisteredInvoice: {
    page: 1
  }
};

const filter = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_INVOICE_PAGE :
      return Object.assign({}, state, {
        invoice: action.payload
      });
    case types.SET_PREREGISTERED_INVOICE_PAGE :
      return Object.assign({}, state, {
        preregisteredInvoice: action.payload
      });
    case types.SET_SCROLL_POSITION :
      return Object.assign({}, state, {
        scrollPosition: action.payload
      });
    case types.CLEAR_SCROLL_POSITION :
      return Object.assign({}, initialState);
    default:
      return state;
  }
};

export default filter;



/** WEBPACK FOOTER **
 ** ./src/redux/modules/scroll-positions/reducer.js
 **/